window.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header-section');
  const parallaxSections = document.querySelectorAll('.js-parallax');
  const menuToggle = document.querySelector('.header__menu-toggle');
  const headerNav = document.querySelector('.header__nav');
  const menuLinks = document.querySelectorAll('.header__nav a');
  const footerLinks = document.querySelectorAll('.footer__link'); // footer links
  const sections = document.querySelectorAll('section[id]');
  const logoLink = document.querySelector('.header__logo-link');
  // CTAボタンとセカンダリーボタンを含む全てのページ内リンクを取得
  const pageLinks = document.querySelectorAll('a[href^="#"]:not(.header__nav a):not(.footer__link)');

  // Cache navLinks
  const navLinks = Array.from(headerNav.querySelectorAll('a[href^="#"]'));

  // Parallax effect using requestAnimationFrame for smooth performance
  const updateParallax = () => {
    const y = window.scrollY;

    parallaxSections.forEach(section => {
      const factor = 0.1;
      const offset = (y - section.offsetTop) * factor;
      const bg = section.querySelector('.hero__background') || section;
      bg.style.backgroundPosition = `center ${offset}px`;
    });

    window.requestAnimationFrame(updateParallax);  // Continue updating with requestAnimationFrame for smoother performance
  };

  // Scroll behavior
  const handleScroll = () => {
    const y = window.scrollY;
    header.classList.toggle('header--scrolled', y > 50);

    // Active link highlight
    const headerHeight = 60;
    const padding = 10;

    sections.forEach(section => {
      const top = section.offsetTop - headerHeight - padding;
      const bottom = top + section.offsetHeight;
      const id = section.getAttribute('id');

      if (y > top && y <= bottom) {
        navLinks.forEach(link => {
          link.classList.toggle('active', link.getAttribute('href') === `#${id}`);
        });
      }
    });
  };

  let scrollTimeout;
  let ticking = false;

  // Use requestAnimationFrame for smooth scroll handling
  const optimizeScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(optimizeScroll, 100); // Throttle scroll event handling
  });

  // Event bindings
  window.addEventListener('scroll', optimizeScroll);
  handleScroll(); // Initial scroll state

  // Footer links smooth scroll
  footerLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const id = link.getAttribute('href');
      const target = document.querySelector(id);
      if (!target) return;
      scrollToTarget(target);
    });
  });

  if (menuToggle && headerNav) {
    menuToggle.addEventListener('click', () => {
      headerNav.classList.toggle('active');
      menuToggle.classList.toggle('active');
      document.body.classList.toggle('menu-open');
    });
  }

  // Smooth scroll on menu link click
  menuLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const id = link.getAttribute('href');
      const target = document.querySelector(id);
      if (!target) return;

      headerNav.classList.remove('active');
      menuToggle.classList.remove('active');
      document.body.classList.remove('menu-open');

      setTimeout(() => scrollToTarget(target), 100);
    });
  });

  // Smooth scroll on logo click
  if (logoLink) {
    logoLink.addEventListener('click', e => {
      const id = logoLink.getAttribute('href');
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      scrollToTarget(target);
    });
  }

  // 全てのページ内リンクにスクロールハンドラーを追加
  pageLinks.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      const id = button.getAttribute('href');
      const target = document.querySelector(id);
      if (!target) return;
      scrollToTarget(target);
    });
  });

  initSlider();

  // Helpers
  function scrollToTarget(targetElement, callback) {
    const headerHeight = 60;
    const rect = targetElement.getBoundingClientRect();
    const y = window.scrollY + rect.top - headerHeight;

    window.scrollTo({ top: y, behavior: 'smooth' });

    // Final sync after scroll
    setTimeout(handleScroll, 500);
    if (callback) setTimeout(callback, 600);
  }

  function throttle(fn, limit) {
    let waiting = false;
    return (...args) => {
      if (!waiting) {
        fn(...args);
        waiting = true;
        setTimeout(() => (waiting = false), limit);
      }
    };
  }

  function initSlider() {
    const slides = document.querySelectorAll('.slide');
    if (slides.length === 0) return;

    let current = 0;
    setInterval(() => {
      slides[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('active');
    }, 5000);
  }

  // Start parallax effect
  window.requestAnimationFrame(updateParallax);
});
